import type { WayPoint } from '../search/itinerary/types';
import { getWaypointCoordinates } from '../search/itinerary/ItineraryStore';

async function getWp(wp: WayPoint) {
	const coordinates = await getWaypointCoordinates(wp);
	return { ...wp, coordinates };
}

export async function computeSearchParamsItinerary(itinerary: WayPoint[]) {
	const itineraryWithCoordinates = await Promise.all(itinerary.map(getWp));
	return itineraryWithCoordinates;
}
